import { nf } from "./shared";

const COL = { probabile: "text-emerald-400", validato: "text-emerald-300", parziale: "text-amber-400", non_determinabile: "text-amber-400", dati_mancanti: "text-neutral-400" };
const RIP = [["fv_diretto", "FV diretto"], ["batteria", "Da batteria"], ["rete", "Da rete"]];

const Box = ({ l, v, id }) => (
  <div className="rounded-lg border border-neutral-800 px-2 py-1.5" data-testid={id}>
    <div className="text-neutral-500">{l}</div>
    <div className="font-mono font-bold text-white">{v == null ? "non disponibile" : `${nf(v)} kWh`}</div>
  </div>
);

export function ConsumiVesta({ c, anteprima }) {
  const ok = c.consumo_kwh != null;
  return (
    <div className="space-y-2 rounded-xl border border-neutral-800 p-3 text-[11px]" data-testid="consumi-vesta">
      <div className="flex flex-wrap items-center gap-2">
        <b className={COL[c.stato]} data-testid="consumi-vesta-etichetta">{c.etichetta}</b>
        <span className="text-neutral-400" data-testid="consumi-vesta-motivo">{c.motivo}</span>
        {anteprima && <span className="ml-auto rounded-full border border-amber-500/40 px-2 py-0.5 text-amber-400" data-testid="consumi-vesta-anteprima">Anteprima staff · non pubblicata</span>}
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <Box l="Prodotta" v={c.produzione_kwh} id="consumi-vesta-prod" />
        {ok && <><Box l="Consumata" v={c.consumo_kwh} id="consumi-vesta-consumo" /><Box l="Immessa" v={c.immessa_kwh} id="consumi-vesta-immessa" /><Box l="Prelevata" v={c.prelevata_kwh} id="consumi-vesta-prelevata" /></>}
      </div>
      {ok && c.autoconsumo_pct != null && <div className="text-neutral-400">Autoconsumo <b className="text-white">{c.autoconsumo_pct}%</b> · Autosufficienza <b className="text-white">{c.autosufficienza_pct}%</b></div>}
      {ok && c.ripartizione && !c.ripartizione_coerente && <div className="text-neutral-500" data-testid="consumi-vesta-ripartizione-nd">Provenienza del consumo (FV diretto, batteria, rete) non ancora verificata</div>}
      {ok && c.ripartizione_coerente && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-neutral-400" data-testid="consumi-vesta-ripartizione">
          {RIP.map(([k, l]) => <span key={k}>{l}: <b className="text-neutral-200">{c.ripartizione[k]?.kwh == null ? "non verificato" : `${nf(c.ripartizione[k].kwh)} kWh`}</b></span>)}
        </div>
      )}
    </div>
  );
}
